<div class="tenders-theme">
  <mat-toolbar
    style="z-index: 2; background: var(--color-background-toolbar)"
    *ngIf="!(authStateService.userConfig$ | async)"
  >
    <button mat-icon-button (click)="subventionsStateService.toggleSubventionsMenu()" style="color: white">
      <mat-icon>menu</mat-icon>
    </button>
    <h1 style="color: white">Subvenciones</h1>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container full"
    [ngClass]="{ 'sidenav-container-space-top': !(authStateService.userConfig$ | async) }"
    fullscreen
  >
    <mat-sidenav #snav mode="side" [disableClose]="true" [opened]="subventionsStateService.openedMenu$ | async">
      <mat-nav-list>
        <img src="assets/imgs/ceoe/logo_ceoedata-white.svg" />
        <mat-list-item
          role="listitem"
          (click)="selectItem(sidenavItem)"
          [ngClass]="{ selected: sidenavItem.selected }"
          [routerLink]="['/subventions/' + sidenavItem.path]"
          *ngFor="let sidenavItem of sidenavItems"
        >
          <mat-icon mat-list-icon color="accent">
            {{ sidenavItem.icon }}
          </mat-icon>
          <p mat-line color="accent">{{ sidenavItem.name }}</p>
        </mat-list-item>
        <!-- <div class="user-data" *ngIf="authStateServiceCeoe.userConfig$ | async">
          <p>{{ (authStateServiceCeoe.userConfig$ | async).name }}</p>
          <p>{{ (authStateServiceCeoe.userConfig$ | async).email }}</p>
        </div> -->
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <router-outlet></router-outlet>
      <button
        mat-mini-fab
        matTooltip="Expandir menú de filtros"
        color="primary"
        *ngIf="
          !(subventionsStateService.filters$ | async).openedMenu &&
          url.startsWith('/subventions/search') &&
          !url.startsWith('/subventions/search/')
        "
        (click)="toggleMenuFilters()"
        style="position: fixed; z-index: 999; bottom: 6px; right: 6px"
      >
        <mat-icon>keyboard_double_arrow_left</mat-icon>
      </button>
    </mat-sidenav-content>
    <mat-sidenav
      #snav
      mode="side"
      position="end"
      [disableClose]="true"
      [opened]="(subventionsStateService.filters$ | async).openedMenu"
      *ngIf="url.startsWith('/subventions/search') && !url.startsWith('/subventions/search/')"
      class="search-filters-sidenav"
      [style.display]="(subventionsStateService.filters$ | async).openedMenu ? 'block' : 'none'"
    >
      <app-subventions-search-filters></app-subventions-search-filters>
    </mat-sidenav>
  </mat-sidenav-container>
</div>
